/*
 * File: input-dynamic-tree-select.ts
 * File Created: 2024-06-27 11:56:57
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-29 09:35:12
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop, Inject } from "vue-property-decorator";
import { BaseInputComponent } from "../core/lib";
import { PropInnateSync } from "@root/core/vue-props";
import { StringHelper } from "@root/core";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";

export interface InputDynamicTreeSelectValue {
    model: string;
    id?: string;
}

@Component
export default class InputDynamicTreeSelect extends BaseInputComponent {
    /// all $attrs pass through into InputTreeSelect ///
    /// { model: string, id?: string }
    @PropInnateSync("value", { type: String, default: undefined })
    innateValue!: string | undefined;

    /// optional.
    /// default provided by InputDynamicTreeSelect.value.model
    @Prop({ type: Array, required: false })
    quicks?: IQuickUnit[];

    /// helpers
    get transformedValue() {
        return typeof this.innateValue !== "string"
            ? null
            : StringHelper.toObject(this.innateValue);
    }
    get generatedValue() {
        const id = this.transformedValue?.id;
        if (id == null) return null;
        return { id };
    }
    get generatedQuicks() {
        if (this.quicks != null) return this.quicks;
        const qmap = UIQuick.getInstanceMap();
        const quicks = qmap[this.transformedValue?.model];
        return quicks == null ? [] : [quicks];
    }

    handleInput(value) {
        const data = { model: this.transformedValue?.model, id: value?.id };
        this.innateValue = JSON.stringify(data);
    }
}
